<script>
  import AddressStore from './stores.js';

	let input_address;
  const addresses = {};

  async function add_address(ip) {
    let request_url = 'https://dip.api.paxavis.dev/checkip?ip=' + ip;
    let result = await fetch(request_url)
      .then((response) => response.json())
      .then((data) => { return data });

    if (result.error == null) {
      let ip_range = result.result.range;
      if (addresses[ip_range] == null) {
        addresses[ip_range] = result.result;
        addresses[ip_range].count = 1;
        addresses[ip_range].seen_ips = new Set();
      } else {
        addresses[ip_range].count++;
      }
      addresses[ip_range].seen_ips.add(ip);
      AddressStore.set(addresses);
    } else {
      // TODO: Make warning pop up
      console.log(result.error);
    }
  }

  async function handle_input() {
    let ips = input_address.split(",");
    await Promise.all(ips.map(async (ip) => {
      await add_address(ip)
    }));
  }
</script>

<div class="flex justify-center">
  <div class="input-group relative flex flex-wrap items-stretch w-full mb-4">
    <input class="form-control relative flex-auto min-w-0 block px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" bind:value={input_address}>
    <button class="btn inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700  focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out flex items-center" on:click={handle_input}>
      🔍 Search
    </button>
  </div>
</div>
